import { getDefaultExportFromCjs as e } from "./help-center-articles-search28.js";
import { __require as o } from "./help-center-articles-search20.js";
var r = o();
const s = /* @__PURE__ */ e(r);
export {
  s as default
};
//# sourceMappingURL=help-center-articles-search12.js.map
